import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(r => setS(r.data)); }, []);
  if (!s) return <p className="text-ivory/50">Loading…</p>;

  const cards = [
    ["Products", s.products], ["Chapters", s.chapters], ["Campaigns", s.campaigns],
    ["Orders", s.orders], ["Pre-orders", s.preorders], ["Clients", s.customers], ["Newsletter", s.newsletter],
  ];

  return (
    <div>
      <p className="text-[10px] tracking-luxury uppercase text-gold mb-4">The House</p>
      <h1 className="font-editorial text-5xl mb-16 tracking-tight">Overview</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-ivory/10">
        {cards.map(([label, val]) => (
          <div key={label} data-testid={`stat-${label.toLowerCase().replace(/[^a-z]/g,'')}`} className="bg-onyx p-8">
            <p className="text-[10px] tracking-widest-plus uppercase text-ivory/50">{label}</p>
            <p className="font-editorial text-5xl mt-4">{val}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
